import { ArrowLeftOutlined } from '@ant-design/icons';
import { Layout, Typography } from 'antd';
import { Link } from 'react-router-dom';

import * as S from './styled';

import { useTheme } from '../../hooks/useTheme';
import { isIntelbrasTenant } from '../../utils/isIntelbrasTenant/isIntelbrasTenant';
import { Shell } from '../atoms/Shell/Shell';

const { Header } = Layout;
const { Title } = Typography;

const HeaderCreateAccount = () => {
  const { theme } = useTheme();

  return (
    <S.HeaderWrapper>
      <Header
        style={{
          backgroundColor: '#fff',
          border: 'none',
          boxShadow:
            '0 0.46875rem 2.1875rem rgba(8,10,37,.03), 0 0.9375rem 1.40625rem rgba(8,10,37,.03), 0 0.25rem 0.53125rem rgba(8,10,37,.05), 0 0.125rem 0.1875rem rgba(8,10,37,.03)',
          minHeight: 64,
          padding: 0,
        }}
      >
        <div className='hdr-inner'>
          {/* ESQUERDA: seta + logo(s) */}
          <div className='left'>
            <Link to='/auth/login' aria-label='Voltar' className='back'>
              <ArrowLeftOutlined />
            </Link>

            {isIntelbrasTenant() ? (
              <S.IntelbrasLogoWrapper className='logo'>
                <Link to='/auth/createaccount'>
                  {theme ? (
                    <img
                      src={`https://storage.googleapis.com/mk-move-repository/white-label/${theme}/images/dash-logo.png`}
                      className={`${theme}-logo-header`}
                      alt='logo'
                    />
                  ) : (
                    <Shell height={24} width={96} />
                  )}

                  {theme === 'celesc' && (
                    <>
                      <img
                        src={`https://storage.googleapis.com/mk-move-repository/white-label/${theme}/images/dash-logo2.png`}
                        className={`${theme}-logo2-header extra`}
                        alt=''
                      />
                      <img
                        src={`https://storage.googleapis.com/mk-move-repository/white-label/${theme}/images/dash-logo3.png`}
                        className={`${theme}-logo3-header extra`}
                        alt=''
                      />
                    </>
                  )}

                  {isIntelbrasTenant() && (
                    <span className='product'>CVE-Pro</span>
                  )}
                </Link>
              </S.IntelbrasLogoWrapper>
            ) : (
              <S.LogoWrapper className='logo'>
                <Link to='/auth/createaccount'>
                  {theme ? (
                    <img
                      src={`https://storage.googleapis.com/mk-move-repository/white-label/${theme}/images/dash-logo.png`}
                      className={`${theme}-logo-header`}
                      alt='logo'
                    />
                  ) : (
                    <Shell height={24} width={96} />
                  )}
                </Link>
              </S.LogoWrapper>
            )}
          </div>

          {/* CENTRO: título responsivo */}
          <div className='center'>
            <Title level={5} className='title'>
              Criação de conta
            </Title>
          </div>

          {/* DIREITA: espaçador para balancear o centro */}
          <div className='right' />
        </div>
      </Header>
    </S.HeaderWrapper>
  );
};

export default HeaderCreateAccount;
